import ClaimantDecisionContainer from "./ClaimantDecisionContainer";

export default ClaimantDecisionContainer;
